import type { Component } from '@/types/components'

export enum BlockType {
  Nested = 'nested',
  Content = 'content',
  Universal = 'universal',
}

export const blockTypeFromComponent = (
  component: Pick<Component, 'is_root' | 'is_nestable'>,
): BlockType => {
  if (component.is_root && component.is_nestable) {
    return BlockType.Universal
  } else if (component.is_root) {
    return BlockType.Content
  }

  return BlockType.Nested
}

export const componentFromBlockType = (
  blockType: BlockType,
): Pick<Component, 'is_root' | 'is_nestable'> => ({
  is_root: blockType === BlockType.Content || blockType === BlockType.Universal,
  is_nestable:
    blockType === BlockType.Nested || blockType === BlockType.Universal,
})
